import { Box, Stack, Typography } from '@mui/material'
import type { ReactNode } from 'react'

interface Props {
  icon: ReactNode
  value: string
  label: string
}

export function StatCard({ icon, value, label }: Props) {
  return (
    <Stack
      alignItems="center"
      sx={{
        flex: '1 1 0',
        minHeight: 132,
        py: 2,
        px: 2,
        borderRadius: 1,
        bgcolor: t => t.vars.palette.background.default,
        border: t => `1px solid ${t.vars.palette.divider}`,
        minWidth: 110,
      }}
    >
      <Box sx={{ height: 48, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        {icon}
      </Box>

      <Typography
        variant="h6"
        align="center"
        sx={{ fontWeight: 500, width: '100%', overflowWrap: 'anywhere' }}
      >
        {value}
      </Typography>
      <Typography variant="caption" color="text.secondary" align="center">
        {label}
      </Typography>
    </Stack>
  )
}
